import { render, staticRenderFns } from "./PayoutDetails.vue?vue&type=template&id=156c78e3&"
import script from "./PayoutDetails.vue?vue&type=script&lang=js&"
export * from "./PayoutDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports